import { z } from 'zod';

export const CogniteFunctionCallErrorResponse = z.object({ error: z.string() });

export const CogniteFunctionCallResponseType = z.object({
  response: z.record(z.string(), z.unknown()).or(CogniteFunctionCallErrorResponse),
  functionId: z.number().int().min(1).max(9007199254740991).describe('A server-generated ID for the object.'),
  callId: z.number().int().min(1).max(9007199254740991).describe('A server-generated ID for the object.'),
});

export type CogniteFunctionCallResponseType = z.infer<typeof CogniteFunctionCallResponseType>;
